import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import MobileCTA from "./components/MobileCTA";
import Home from "./pages/Home";
import Industries from "./pages/Industries";
import Uniforms from "./pages/Uniforms";
import CustomManufacturing from "./pages/CustomManufacturing";
import Fabrics from "./pages/Fabrics";
import GarmentDetail from "./pages/GarmentDetail";
import ExportPage from "./pages/Export";
import About from "./pages/About";
import BulkQuote from "./pages/BulkQuote";
import Contact from "./pages/Contact";
import { Privacy, Terms } from "./pages/Legal";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      <main className="pt-16 lg:pt-20">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/uniforms" element={<Uniforms />} />
          <Route path="/uniforms/:slug" element={<GarmentDetail />} />
          <Route path="/fabrics" element={<Fabrics />} />
          <Route path="/custom-manufacturing" element={<CustomManufacturing />} />
          <Route path="/export" element={<ExportPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/bulk-quote" element={<BulkQuote />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      <div className="h-[57px] md:hidden" aria-hidden="true" />
      <MobileCTA />
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
